import { combineReducers } from 'redux';
import sampleReducer from "./sampleRedux/reducer"

const rootReducer = combineReducers({
  counter: sampleReducer
});

export default rootReducer;